// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Box from "../resources/layout-and-structure/Box.res.js";
import * as Nav from "../resources/navigation/Nav.res.js";
import * as Page from "../resources/layout-and-structure/Page.res.js";
import * as Banner from "../resources/feedback-indicators/Banner.res.js";
import * as Inline from "../resources/layout-and-structure/Inline.res.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as PageBottomActionsBar from "../resources/layout-and-structure/PageBottomActionsBar.res.js";

function ResourceDetailsPage$ActionsBar(props) {
  return JsxRuntime.jsx(Inline.make, {
    children: props.items,
    space: "small"
  });
}

let ActionsBar = {
  make: ResourceDetailsPage$ActionsBar
};

function ResourceDetailsPage$NotificationBanner(props) {
  let value = props.value;
  let tmp;
  tmp = value.TAG === "Ok" ? ({
      TAG: "Success",
      _0: value._0
    }) : ({
      TAG: "Danger",
      _0: value._0
    });
  return JsxRuntime.jsx(Banner.make, {
    textStatus: tmp,
    onRequestClose: props.onRequestClose
  });
}

let NotificationBanner = {
  make: ResourceDetailsPage$NotificationBanner
};

function ResourceDetailsPage(props) {
  let notificationBanner = props.notificationBanner;
  let match = Nav.Context.use();
  let renderActionsBar = Stdlib_Option.map(props.actionsBar, element => (() => element));
  let renderTitleEnd = Stdlib_Option.map(props.statusBadge, element => (() => element));
  return JsxRuntime.jsxs(Page.make, {
    children: [
      notificationBanner !== undefined ? JsxRuntime.jsx(Box.make, {
          children: notificationBanner,
          spaceTop: "medium"
        }) : null,
      JsxRuntime.jsx(Box.make, {
        children: props.children,
        spaceTop: "large",
        grow: true
      }),
      renderActionsBar !== undefined ? JsxRuntime.jsx(PageBottomActionsBar.make, {
          renderEnd: renderActionsBar,
          navOpened: match[0].opened
        }) : null
    ],
    variation: props.variation,
    title: props.title,
    subtitle: props.subtitle,
    renderTitleEnd: renderTitleEnd,
    renderActions: renderActionsBar
  });
}

let make = ResourceDetailsPage;

export {
  ActionsBar,
  NotificationBanner,
  make,
}
/* Box Not a pure module */
